/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/analytics',
          name: 'analytics',
          component: () => import('./views/Analytics.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/footfall',
          name: 'footfall',
          component: () => import('./views/Footfall.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/application',
          name: 'application',
          component: () => import('./views/ApplicationList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/application-details/:id',
          name: 'application-details',
          component: () => import('./views/ApplicationDetails.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/profile-details/:type/:applicant_id/:id/:phone',
          name: 'profile-details',
          component: () => import('./views/components/ProfileDetails.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicant-list',
          name: 'applicant-list',
          component: () => import('./views/ApplicantList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/nid-validated-applicant',
          name: 'nid-validated-applicant',
          component: () => import('./views/NidValidatedApplicant.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/search-application',
          name: 'search-applicant-list',
          component: () => import('./views/SearchApplication.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicant-details/:id',
          name: 'applicant-details',
          component: () => import('./views/ApplicantDetails.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update-contact/:ekyc_id',
          name: 'update-contact',
          component: () => import('./views/components/UdateApplicantContactInfo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update-occupation/:ekyc_id',
          name: 'update-contact',
          component: () => import('./views/components/UdateApplicantOccupationInfo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update-dependant/:ekyc_id',
          name: 'update-dependant',
          component: () => import('./views/components/UdateApplicantDependantInfo.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/update-personal/:ekyc_id',
          name: 'update-personal',
          component: () => import('./views/components/UdateApplicantPersonal.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/change-request',
          name: 'change-request',
          component: () => import('./views/ChangeRequest'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/profile-update-new',
          name: 'profile-update-new',
          component: () => import('./views/UpdateRequestFrmApplicant.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/application-details-send-back/:id',
          name: 'application-details-send-back',
          component: () => import('./views/ApplicationDetailsForSendBack'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicant-personal-info_update/:id',
          name: 'applicant-personal-info_update',
          component: () => import('./views/components/UdateApplicantPersonalForProfileUpdate'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicant-contact-info-update/:id',
          name: 'applicant-contact-info-update',
          component: () => import('./views/components/UdateApplicantContactForProfileUpdate'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicant-occupation-info-update/:id',
          name: 'applicant-occupation-info-update',
          component: () => import('./views/components/UdateApplicantOccuForProfileUpdate'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/applicant-dependant-info-update/:id',
          name: 'applicant-dependant-info-update',
          component: () => import('./views/components/UdateApplicantDependantForProfileUpdate'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/guarantor-list',
          name: 'guarantor-list',
          component: () => import('./views/GuarantortList.vue'),
          meta: {
            requiresAuth: true
          }
        },
/*        {
          path: '/compare-app',
          name: 'compare-app',
          component: () => import('./views/components/UploadDefault.vue'),
          meta: {
            requiresAuth: true
          }
        },*/
        {
          path: '/compare-application',
          name: 'compare-application',
          component: () => import('./views/components/ExcelCompare'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/profile-update',
          name: 'profile-update',
          component: () => import('./views/components/ProfileUpdateList.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/report',
          name: 'report',
          component: () => import('./views/components/Report.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/agreementReport',
          name: 'agreementReport',
          component: () => import('./views/components/AgreementReport.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/purchase-history',
          name: 'purchase-history',
          component: () => import('./views/PurchaseHistory.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/guarantor-details/:id',
          name: 'guarantor-details',
          component: () => import('./views/GuarantorDetails.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/showroom',
          name: 'showroom',
          component: () => import('./views/Showroom.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/showroom/add-showroom',
          name: 'add-showroom',
          component: () => import('./views/AddShowroom.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/showroom/showroom-update/:suffix',
          name: 'update-showroom',
          component: () => import('./views/UpdateShowroom.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/showroom/view-showroom/:suffix',
          name: 'view-showroom',
          component: () => import('./views/ViewShowroom.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/users',
          name: 'users',
          component: () => import('./views/Users.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/users/add-user',
          name: 'add-users',
          component: () => import('./views/AddUser.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/user-profile',
          name: 'user-profile',
          component: () => import('./views/ActiveUser.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/users/update-user/:userId',
          name: 'update-user',
          component: () => import('./views/UpdateUser.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/change-password/:userId',
          name: 'change-password',
          component: () => import('./views/ChangePassword.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/users/assign-showroom/:userId',
          name: 'assign-showroom',
          component: () => import('./views/components/UserAssignShowroom.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import('./views/Settings.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/try_and_buy',
          name: 'try_and_buy',
          component: () => import('./views/WashingMachineTrail.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/try_and_buy_detail/:id',
          name: 'try_and_buy-detail',
          component: () => import('./views/WashingMachineTrailDetails.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/find-agreement',
          name: 'agreement-by-user',
          component: () => import('./views/AgreementFilter'),
          meta: {
            requiresAuth: true
          }
        }

      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if NO logged user
    if (!store.getters.accessToken) {
      // Go to login
      next({
        path: '/pages/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Proceed to route
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if NO logged user
    if (store.getters.accessToken) {
      // Go to login
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      // Proceed to route
      next()
    }
  } else {
    // Proceed to route
    next()
  }
})
export default router

